/* eslint-disable no-console */
import { Menu, MenuItem } from '@mui/material';
import React, { useContext, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { FaRegCheckCircle } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { MuiPaperProps, queryParams } from '../../../libs/HelperContent';
import { updateFolderAccess } from '../../actions/folder_action';
import { toast } from 'react-toastify';
import useGetMyFolders from '../customHooks/useGetMyFolder';
import Loading from '../../../components/Common/Loaders/FullWidthLoader/Loading';
import NoneAccessPopup from './NoneAccessPopup';
import PropTypes from 'prop-types';
import { LanguageContext } from '../../../libs/Context';

const ShareMenuItem = ({ eachRelation, eachRelationMember, shareFiles,
	type, updateShareData }) =>
{
	const session:any = useSelector((state:any) => state?.mysession?.session);
	const queryParamRes = queryParams(session?.userId, session?.companyId, session?.empRole, session?.role, 'get');
	const [ anchorEl, setAnchorEl ] = useState<null | HTMLElement>(null);
	const [ loading, setLoading ] = useState<boolean>(false);
	const [ openNoneAccessPopup, setOpenNoneAccessPopup ] = useState(false);
	const { language } = useContext(LanguageContext);

	const getFoldersData = useGetMyFolders({});

	const accessRelated = (id:any = '') =>
	{
		if (id && shareFiles?.data?.shareTo?.length > 0)
		{
			const eachObj:any = shareFiles?.data?.shareTo?.find((each:any) => each?.id === id);

			return eachObj;
		}
	};
	const accessId:any = eachRelation
		? (session?.empRole === 'employee' ? session?.companyId?.replaceAll('-', '') : eachRelation?.relationId)
		:	eachRelationMember
			? eachRelationMember?.userId || eachRelationMember?.id
			: '';
	const [ acccessData, setAccessData ] = useState<any>(accessRelated(accessId) || null);

	const open = Boolean(anchorEl);

	const handleClose = () =>
	{
		setAnchorEl(null);
	};

	const handleClick = (event) =>
	{
		setAnchorEl(event.currentTarget);
	};

	const renderValues = {
		1 : 'None',
		2 : 'View',
		3 : 'Edit'
	};

	const checkAccessOptions = () =>
	{
		if (eachRelation)
		{
			return renderValues[acccessData?.access];
		}
		else if (eachRelationMember)
		{
			return renderValues[acccessData?.access];
		}
	};

	const updateShareAccess = async (e:any, item:any, accessValue:number = 0) =>
	{
		if (acccessData && acccessData?.access === accessValue)
		{
			handleClose();
		}
		else
		{
			try
			{
				const query = `?type=shareAccess${queryParamRes}`;
				const body = {
					id      : shareFiles?.data?.folderId,
					shareTo : {
						id     : (session?.empRole === 'employee' && type === 'relation') ? session?.companyId?.replaceAll('-', '') : eachRelation ? item?.relationId : (item?.id || item?.userId),
						type   : (session?.empRole === 'employee' && type === 'relation') ? 'company internal employees' : eachRelation ? item?.relation : item?.role,
						access : accessValue
					}
				};

				setLoading(true);
				const res = await updateFolderAccess(body, query);

				if (res?.status)
				{
					toast.success(language.accessUploadsuccess, {
						position : toast.POSITION.TOP_RIGHT
					});
					getFoldersData();
					const accessData = {
						...acccessData,
						id     : (session?.empRole === 'employee' && type === 'relation') ? session?.companyId?.replaceAll('-', '') : eachRelation ? item?.relationId : (item?.id || item?.userId),
						type   : (session?.empRole === 'employee' && type === 'relation') ? 'company internal employees' : eachRelation ? item?.relation : item?.role,
						access : accessValue
					};

					setAccessData(accessData);
					handleClose();
					setOpenNoneAccessPopup(false);
					setLoading(false);
					updateShareData(accessData);
				}
				else
				{
					handleClose();
					setLoading(false);
				}
			}
			catch (error:any)
			{
				toast.error(error?.response?.data?.error, {
					position : toast.POSITION.TOP_RIGHT
				});
				setLoading(false);
			}
		}
	};

	const handleAccessClose = () =>
	{
		setOpenNoneAccessPopup(false);
	};

	const handleSave = (e) =>
	{
		updateShareAccess(e, eachRelation || eachRelationMember, 1);
	};

	const handleAccessClick = (e) =>
	{
		if (checkAccessOptions() === 'Edit' || checkAccessOptions() === 'View')
		{
			setOpenNoneAccessPopup(true);
		}
		else
		{
			updateShareAccess(e, eachRelation || eachRelationMember, 1);
		}
	};

	const KeyUpFunc = (e) =>
	{
		if (e.key === 'Enter')
		{
			if (checkAccessOptions() === 'Edit' || checkAccessOptions() === 'View')
			{
				setOpenNoneAccessPopup(true);
			}
			else
			{
				updateShareAccess(e, eachRelation || eachRelationMember, 1);
			}
		}
	};

	return (
		<>
			<div className='flexAutoRow'>
				<span>{(eachRelation && (renderValues[acccessData?.access] || 'None')) || (eachRelationMember && (renderValues[acccessData?.access] || 'None'))}</span>
				<button
					tabIndex={0}
					onKeyUp={(e) => { e.key === 'Enter' && handleClick(e); }}
					className='pointer' onClick={handleClick}
				><KeyboardArrowDownIcon/></button>
				{loading && <Loading/>}
				<Menu
					id='demo-positioned-menu'
					aria-labelledby='demo-positioned-button'
					anchorEl={anchorEl}
					open={open}
					onClose={handleClose}
					PaperProps={MuiPaperProps}
					transformOrigin={{ horizontal: 'right', vertical: 'top' }}
					anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
				>
					<MenuItem>
						<div className='flexRow'>
							<div className='flexAutoRow pdngTXXXS'>
								{checkAccessOptions() === 'None' &&
								<FaRegCheckCircle className='primaryTxt'/>
								}
							</div>
							<button tabIndex={0}
								onKeyUp={(e) => KeyUpFunc(e)}
								className='flexMinWidthRow'
								onClick={handleAccessClick}
							>
								<div className='flexAutoCol'>
									<span className={checkAccessOptions() === 'None' ? 'primaryTxt' : ''}>{language.none}</span>
									<span className='lightTxt subHeadingXS'>{language.peopleCannotView}</span>
								</div>
							</button>
						</div>
					</MenuItem>
					<MenuItem>
						<div className='flexRow'>
							<div className='flexAutoRow pdngTXXXS'>
								{checkAccessOptions() === 'View' &&
								<FaRegCheckCircle className='primaryTxt'/>
								}
							</div>
							<button
								className='flexMinWidthRow'
								tabIndex={0}
								onKeyUp={(e) => { e.key === 'Enter' && updateShareAccess(e, eachRelation || eachRelationMember, 2); }}
								onClick={(e) => updateShareAccess(e, eachRelation ||
									eachRelationMember, 2)}
							>
								<div className='flexAutoCol'>
									<span className={checkAccessOptions() === 'View' ? 'primaryTxt' : ''}>{language.view}</span>
									<span className='lightTxt subHeadingXS'>{language.viewDownload}</span>
								</div>
							</button>
						</div>
					</MenuItem>
					<MenuItem>
						<div className='flexRow'>
							<div className='flexAutoRow pdngTXXXS'>
								{checkAccessOptions() === 'Edit' &&
								<FaRegCheckCircle className='primaryTxt'/>
								}
							</div>
							<button className='flexMinWidthRow'
								tabIndex={0}
								onKeyUp={(e) => { e.key === 'Enter' && updateShareAccess(e, eachRelation || eachRelationMember, 3); }}
								onClick={(e) => updateShareAccess(e, eachRelation ||
									eachRelationMember, 3)}
							>
								<div className='flexAutoCol'>
									<span className={checkAccessOptions() === 'Edit' ? 'primaryTxt' : ''}>{language.edit}</span>
									<span className='lightTxt subHeadingXS'>{language.CRUDAccess}</span>
								</div>
							</button>
						</div>
					</MenuItem>
				</Menu>
			</div>
			{openNoneAccessPopup &&
				<NoneAccessPopup
					handleClose={handleAccessClose}
					handleSave={handleSave}
					loading={loading}
				/>
			}
		</>
	);
};

ShareMenuItem.propTypes = {
	eachRelation       : PropTypes.object,
	eachRelationMember : PropTypes.object,
	shareFiles         : PropTypes.object,
	closeShare         : PropTypes.func,
	type               : PropTypes.string,
	updateShareData    : PropTypes.func
};

export default ShareMenuItem;